<template>
  <div class>
    <Nav></Nav>
    <mdb-container class="mt-5">
      <mdb-row class="flex-center">
        <mdb-col sm="12" xl="7" class="form">
          <h4 class="mt-5">PERSONAL INFO</h4>
          <label for="name">E-mail</label>
          <input required readonly type="text" id="name" class="form-control" v-model="email" />
          <label for="name">Nickname</label>
          <input
            required
            type="text"
            id="name"
            class="form-control"
            v-model="profilePersonalInfo.nickname"
          />

          <router-link to="/password-reset" class="mt-5">Change password</router-link>
          <mdb-btn
            @click="mthButtonUpdateYourProfile"
            color="primary"
            class="m-0 mt-3 mb-5 outline float-right btn-sm"
            rounded
          >Update your profile</mdb-btn>
        </mdb-col>
      </mdb-row>
      <mdb-row class="flex-center mt-3 mb-3">
        <mdb-col sm="12" xl="7" class="form">
          <label for="name">Avatar</label>
          <upload-avatar
            v-on:url="mthProcessKnownUrl"
            v-on:childToParent="onChildAvatarUploaded"
            class="upload-avatar mb-4"
            :nickname="profilePersonalInfo.nickname"
          ></upload-avatar>
        </mdb-col>
      </mdb-row>
      <mdb-row class="flex-center">
        <mdb-col sm="12" xl="7" class="form">
          <h4 class="mt-2 pt-2">YOUR BUSINESS</h4>

          <p class="mb-3">
            <strong>None of this information will be shown on your profile.</strong> This information will be used to help customize your learning experience on Exsellance.
          </p>

          <template v-for="(item,index) in profileYourBusiness">
            <label :for="item.label" :key="'l'+index">{{item.label}}</label>

            <input
              :id="item.label"
              v-if="item.type=='input'"
              v-model="item.value"
              type="text"
              :key="'i'+index"
              class="form-control"
            />
            <select
              ref="refselect"
              v-if="item.type=='select'"
              v-model="item.value"
              :key="'s'+index"
            >
              <option v-for="(option,index) in item.options" :key="index.toString+option">{{option}}</option>
            </select>
            <textarea
              v-if="item.type=='textarea'"
              v-model="item.value"
              :key="'t'+index"
              rows="5"
              cols="20"
            />
          </template>

          <!-- its better to jump to profile in code, not sure of this behaviour -->
          <!-- <router-link to="/profile"> -->
          <mdb-btn
            @click="mthButtonUpdateYourProfile"
            color="primary"
            class="m-0 mt-3 outline float-right btn-sm"
            rounded
          >UPDATE YOUR PROFILE</mdb-btn>
          <!-- </router-link> -->
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
//#region imports
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import UploadAvatar from "../components/UploadAvatar";
import firebase from "firebase/app";
import moment from "moment";
import { store } from "../store";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbProgress
} from "mdbvue";
//#endregion

export default {
  name: "Profile",
  data: function() {
    return {
      email: "",
      profilePersonalInfo: {
        nickname: "",
        avatarUrl: ""
      },
      profileYourBusiness: [
        { label: "Company Name", value: "", type: "input" },
        {
          label: "Established since (year)",
          value: "",
          type: "select",
          options: [
            "Not Yet formed",
            "2019",
            "2018",
            "2017",
            "2016",
            "2015",
            "Before 2015"
          ]
        },
        {
          label: "Your role",
          value: "",
          type: "select",
          options: [
            "Founder",
            "Sales Professional",
            "Business Development",
            "Other"
          ]
        },
        {
          label: "Industry",
          value: "",
          type: "select",
          options: [
            "Agriculture, mining and utilities",
            "Manufacturing",
            "Construction",
            "Retail",
            "Transportation",
            "Accommodation & food",
            "ICT",
            "Financial and insurance",
            "Real estate activities",
            "Professional and scientific",
            "Administrative & support service",
            "Education",
            "Health and social work",
            "Arts and recreation",
            "Other service activities"
          ]
        },
        {
          label: "Number of employees",
          value: "",
          type: "select",
          options: ["Just me", "1-3", "4-5", "6-10", "11+"]
        },
        {
          label:
            "What was it about this platform that attracted you to sign up?",
          value: "",
          type: "textarea"
        },
        {
          label: "Current Revenue (past 12 months)",
          value: "",
          type: "select",
          options: ["Zero", "1 – 500k", "501 – 1m", "1m – 2m", "2m – 5m", "5m+"]
        },
        {
          label: "Target Revenue (next 12 months)",
          value: "",
          type: "select",
          options: [
            "Increase by 5%",
            "Increase by 10%",
            "Increase by 15%",
            "Increase by 20%",
            "Increase by 25%",
            "Increase by 30%",
            "Increase by 35%",
            "Increase by 40%",
            "Increase by 45%+"
          ]
        },
        {
          label: "Current Clients (last 12 months)",
          value: "",
          type: "select",
          options: [
            "Zero",
            "1 – 10",
            "11 – 20",
            "21 – 30",
            "31 – 40",
            "41 – 50",
            "50 – 80",
            "81 – 100",
            "100+"
          ]
        },
        {
          label: "Target Clients (next 12 months)",
          value: "",
          type: "select",
          options: [
            "Increase by 5%",
            "Increase by 10%",
            "Increase by 15%",
            "Increase by 20%",
            "Increase by 25%",
            "Increase by 30%",
            "Increase by 35%",
            "Increase by 40%",
            "Increase by 45%+"
          ]
        },
        {
          label: "What are your top three sales challenges today?",
          value: "",
          type: "textarea"
        }
      ]
    };
  },

  components: {
    Nav,
    Footer,
    UploadAvatar,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbProgress
  },
  methods: {
    mthProcessKnownUrl(v) {
      //console.log("%c mthProcessKnownUrl has: " + v, "color: red;");
      if (v && v !== "") {
        this.profilePersonalInfo.avatarUrl = v;
        store.commit("setAvatarurl", v);
      }
    },
    onChildAvatarUploaded(value) {
      //console.log("%c onChildAvatarUploaded fired", "color: red");

      //console.log(value);
      this.fromChild = value;
    },
    mthGetProfileYourBusinessFromAssessment() {
      //console.log(
      //   "will try to get business profile section from last assessment"
      // );

      let email = store.getters.getUser.email;
      //console.log("email 266: " + email);

      let that = this;

      firebase
        .firestore()
        .collection("usersFilledAssessments")
        .where("user", "==", email)
        .orderBy("createdAt", "desc")
        .limit(1)
        //.doc(this.$router.currentRoute.params.filledassessmentidrouterparam)
        //.doc(this.$store.getters.getAssessmentIdParam)
        //.doc()
        .get()
        .then(result => {
          //console.log("user filled assessment data is:");
          //console.log(result);

          if (typeof result === "undefined") {
            //console.log(
            //   "%c no business profile data in assessment",
            //   "color: orange;"
            // );
          } else {
            //console.log(
            //   "%c taking profile business from assessment",
            //   "color: green;"
            // );

            result.forEach(doc => {
              //console.log(doc.data().postAssessmentForm);

              //console.log("%c postAssessmentForm: ", "font-weight: bold;");
              //console.log(doc.data().postAssessmentForm);

              if (typeof doc.data().postAssessmentForm !== "undefined")
                that.profileYourBusiness = doc.data().postAssessmentForm;
              //console.log("270 profileYourBusiness: ");
              //console.log(that.profileYourBusiness);
            });
          }
        });
    },
    mthfillProfileYourBusinessPartIfEmptyOtherwiseGetFromAssessment() {
      let email = store.getters.getUser.email;
      this.email = email;
      let that = this;

      //console.log("291 nick is " + this.profilePersonalInfo.nickname);

      let userProfileDocRef = firebase
        .firestore()
        .collection("usersProfiles")
        .doc(email);

      var userProfileDoc = userProfileDocRef
        .get()
        .then(doc => {
          //console.log("%c taking personal", "color: red");
          //console.log(doc.data().profilePersonalInfo);

          //personal, nick and email
          if (
            doc.data().profilePersonalInfo &&
            doc.data().profilePersonalInfo.nickname !== ""
          ) {
            this.profilePersonalInfo = doc.data().profilePersonalInfo;
          } else if (email && email !== "") {
            this.profilePersonalInfo.nickname = email.split("@")[0];
          }

          //business, like at the end of assessment
          var profileYourBusinessIsFilledInTheProfile = false;

          //console.log("biz is");

          //console.log(doc.data().profileYourBusiness);

          if (typeof doc.data().profileYourBusiness === "undefined") {
            //console.log("got shitty undefined");
          } else {
            profileYourBusinessIsFilledInTheProfile = true;
          }

          //console.log(doc.data().profilePersonalInfoaaaaa);

          if (!profileYourBusinessIsFilledInTheProfile) {
            //console.log("business profile is empty, getting from assessment");
            that.mthGetProfileYourBusinessFromAssessment();
            // console.log("299 profileYourBusiness: ");
            // console.log(that.profileYourBusiness);
          } else {
            //profile not empty, just bind
            //console.log(
            //   "304 getting profileYourBusiness from usersProfiles, doc.data().profileYourBusiness"
            // );
            this.profileYourBusiness = doc.data().profileYourBusiness;

            //also bind personal info
          }
        })
        .catch(err => {
          //console.log("userProfileDoc - Error getting document", err);
        });
    },
    mthButtonUpdateYourProfile() {
      //console.log("%c mthButtonUpdateYourProfile", "color: orange;");
      //console.log("%c data prepared to save: ", "color: green;");
      //console.log("%c personalInfo: ", "color: green;");
      //console.log(this.profilePersonalInfo);

      firebase
        .firestore()
        .collection("usersProfiles")
        .doc(store.getters.getUser.email)
        .set({
          //set creates if not existing
          profilePersonalInfo: this.profilePersonalInfo,
          profileYourBusiness: this.profileYourBusiness
        });

      let nickname = "Guest";
      if (
        this.profilePersonalInfo.nickname !== undefined &&
        this.profilePersonalInfo.nickname !== ""
      )
        nickname = this.profilePersonalInfo.nickname;

      this.$store.commit("setNickname", nickname);
      if (this.avatarUrl !== undefined && this.avatarUrl !== "")
        this.$store.commit("setAvatarurl", this.avatarUrl);

      this.$router.replace("/profile");
    } //mthButtonUpdateYourProfile
  },
  created() {
    this.mthfillProfileYourBusinessPartIfEmptyOtherwiseGetFromAssessment();
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
</style>
